// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"title-module--header-container--3e6CV","header":"title-module--header--29jls"};